import Vue from 'vue'
//
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
//
const assetUrl = document.getElementById("body").getAttribute("asset-url");
const loaderPng = assetUrl +'/images/loader/loader-2.png'
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {error: loaderPng, loading: loaderPng});
//
import LightBox from 'vue-image-lightbox'
Vue.component("lightbox", LightBox);
//
import VueCoreVideoPlayer from "vue-core-video-player";
Vue.use(VueCoreVideoPlayer);
//
const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
//
import VueClamp from 'vue-clamp'
Vue.component("vue-clamp", VueClamp)
//
import { NavigationMixins } from "@/secured/mixins/nav-mixins";
import { LoginMixins } from "@/secured/mixins/login-mxins";
import { ShareMixins } from "@/secured/mixins/share-mixins";
//
import "@/secured/components/image-gallery";
import "@/secured/components/swiper-col4";
import "@/secured/components/swiper-col2";
import "@/secured/components/watchlist-add-button";
import "@/secured/components/swiper-exhibitors-logos";
//
let app;
//
export let vgrmApp = {
  createApp: (component) => {
    //
    let rootComponent = {
      el: "#app",
      mixins: [NavigationMixins, LoginMixins, ShareMixins],
      setup: () => {
        let result = {};
        if (component?.validations) {
          result.v$ = useVuelidate(component.validations)
        }
        return result;
      },
      data() {
        let result = {};
        if (component?.data) {
          result = component.data;
        }
        result.showLoader = false;
        return result;
      },
      validations() {
        return component?.validations;
      }
    }
    if (component) {
      if (component.methods) {
        rootComponent.methods = component.methods;
      } else {
        rootComponent.methods = {}
      }
      if (component.mounted) {
        rootComponent.mounted = component.mounted;
      }
    } else {
      rootComponent.methods = {}
    }

    //
    rootComponent.methods.hcmsPictureUrl = (picture, cropKey) => {
      if (picture?.length > 0) {
        let pic = picture[0]
        let url = pic.croppedImages
        let suffix = pic.mimeType == "image/png" ? '-png' : ''
        return url +"/" +cropKey +suffix
      }
      return null;
    }
    rootComponent.methods.hcmsPictureDescription = (picture, source) => {
      if (picture?.length > 0) {
        let pic = picture[0]
        let result = pic.description
        if (source && pic.source?.length > 0) {
          result += " (Quelle: " +pic.source +")"
        }
        return result
      }
      return null;
    }
    rootComponent.methods.scrollTo = (id, duration, options) => {
      VueScrollTo.scrollTo(id, duration, options);
    }

    //
    app = new Vue(rootComponent);
  },
  setUploadFile: (e, allowedTypes, mb, callback, callbackError) => {
    let file = e.target.files?.length == 1 ? e.target.files[0] : null;
    if (file) {
      if (allowedTypes.indexOf(file.type) >= 0 && file.size < (mb*1024*1000)) {
        callback(file);
        e.target.value = "";
      } else {
        callbackError()
      }
    }
  },
  hideTextSection: () => {
    document.getElementById("text-content").classList.add("d-none");
  },
  refreshRevive: () => {
    setTimeout(function () { checkReviveAsync() }, 1000)
  }
}

async function checkReviveAsync() {
  for (let i = 0; i < 10; i++) {
    if (window.reviveAsync) {
      //console.log("window.reviveAsync ist gesetzt!");
      const insEl = document.querySelector("[data-revive-id]")
      if (insEl) {
        const reviveId = insEl.getAttribute("data-revive-id")
        // console.log(reviveId)
        // console.log(window.reviveAsync[reviveId])
        window.reviveAsync[reviveId]?.refresh();
        // console.log(window.reviveAsync)
      }
      break; // Loop abbrechen, wenn reviveAsync gefunden wurde
    } else {
      console.log("window.reviveAsync ist noch nicht gesetzt. Warte...");
    }
    await new Promise(resolve => setTimeout(resolve, 200));
  }
}